import { render } from "./TimelineIcon.vue?vue&type=template&id=4e657570"
const script = {}
script.render = render

export default script